<template>
<div class="scrolling-box">  

<a id="top"></a>

<b-container>
  
    <div class="greysearch">
      <b-form @submit.prevent="onSearchBar">
        <b-form-group style="margin-bottom: 3px;">
          <b-input-group :disabled='barOrCheck' >
            <b-input-group-prepend><b-button type="submit" class="input-group-text" variant="db-sb"><font-awesome-icon icon="search"></font-awesome-icon></b-button></b-input-group-prepend>
            <b-form-input :disabled='barOrCheck' v-model="search" @input="startTimeoutSearch"></b-form-input>
            <b-input-group-append>
              <b-input-group-text id="popover-help" style="cursor:pointer;"> 
                <font-awesome-icon icon="question-circle"></font-awesome-icon> 
              </b-input-group-text>
              <b-input-group-text title="Show advanced filters" v-if="!advancedFilter" @click="advancedFilter = !advancedFilter" style="cursor:pointer;"> 
                <font-awesome-layers>
                  <font-awesome-icon icon="plus"></font-awesome-icon>
                  <font-awesome-icon title="Default filters have been modified" v-if="!defaultAdvancedFilters" icon="exclamation-circle" style="color: #ba0000;" transform="shrink-4 down-8 right-8"></font-awesome-icon> 
                </font-awesome-layers>
              </b-input-group-text>
              <b-input-group-text title="Hide advanced filters" v-if="advancedFilter" @click="advancedFilter = !advancedFilter" style="cursor:pointer;"> <font-awesome-icon icon="minus"></font-awesome-icon> </b-input-group-text>
            </b-input-group-append>
            <b-popover
            target="popover-help"
            title="Help with searchbar"
            triggers="hover"
            placement="bottomleft"
            variant="light"
            >
            {{$ml.get('pluginvideop1')}}<br/>
            {{$ml.get('pluginvideop2')}}<br/>
            {{$ml.get('pluginvideop3')}}<br/>
            {{$ml.get('pluginvideop4')}} 
            </b-popover>
            

          </b-input-group>
          <transition name="advancedfilter">
          <b-row v-if="advancedFilter" class="marginaltopsm justify-content-center">
            <b-col cols="auto">
              <!--<b-form-checkbox-group
              size="sm"
              v-model="advancedFilters"
              :options="advancedFilterOptions"
              @input="startTimeoutSearch"
            ></b-form-checkbox-group>-->
            <b-form-checkbox-group
              size="sm"
              v-model="qualityFilters"
              :options="qualityFilterOptions"
              @input="startTimeoutSearch"
            ></b-form-checkbox-group>
            </b-col>
          </b-row>
          </transition>
        <div v-if="clientCollections && clientCollections.length > 0" style="border:solid 1px #ced4da; border-radius:3px;padding: 5px;margin:5px 0px;">
          <h6>Collections:</h6>
          <div style="display:inline-block" v-for="(collection, index) in clientCollections" :key="index">
          
              <div @click="changeCollectionState(collection)" v-if="selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1" class="tagButton tag-not-selected" style="margin-right: 3px;">
                <span style="padding-left:10px;padding-right:10px"><font-awesome-icon  :icon="['fas', 'minus']" style="margin-right:5px" ></font-awesome-icon>
                {{collection}}</span>
              </div>

              <div @click="changeCollectionState(collection)" v-if="selectedCollections.indexOf(collection) != -1 && exludedCollections.indexOf(collection) === -1" class="tagButton tag-selected" style="margin-right: 3px;">
                <span style="padding-left:10px;padding-right:10px"><font-awesome-icon :icon="['fas', 'check']" style="margin-right:5px" ></font-awesome-icon>
                {{collection}}</span>
              </div>

              <div @click="changeCollectionState(collection)" v-if="exludedCollections.indexOf(collection) != -1 && selectedCollections.indexOf(collection) === -1" class="tagButton tag-excluded" style="margin-right: 3px;">
                <span style="padding-left:10px;padding-right:10px"><font-awesome-icon  :icon="['fas', 'times']" style="margin-right:5px" ></font-awesome-icon>       
                {{collection}}</span>
              </div>
              <div style="display:inline;margin-right:15px">
                <b-button variant="greenw" style="cursor:pointer;padding: 2px;line-height:0px;" @click="collectionAuth.id=collection;openCollectionAuthorization(); showModal('authorizationsCollection')">
                  <font-awesome-icon  :icon="['fas', 'cog']"  ></font-awesome-icon> 
                </b-button>
              </div>
            </div>
            <div style="textAlign:center">
              <b-button class="col-auto" variant="msstreamblue" style="padding:6px" @click="selectedCollections=[];exludedCollections=[];startTimeoutSearch()">
                <span v-text="$ml.get('resetCollections')"></span>
              </b-button>
            </div>
          </div>

          <p style="text-align:center; margin-bottom:0px; margin-top:0.5rem; font-size: 90%;">{{$ml.get('filter')}}: <strong>'{{search}}'</strong> -> {{$ml.get('result')}}: <strong>{{numberOfVideos}}</strong>/{{totalNumberOfVideos}} {{$ml.get('pluginvideoplural')}}</p>
        </b-form-group>
      </b-form>
    </div>

    <b-row class="justify-content-between align-items-center" style="margin-right:0px; margin-left:0px; margin-top: 35px; margin-bottom:15px ">
      <b-col cols="auto">
        <b-button-group class="align-items-center">
          <b-button style="margin-right:5px" :variant="(thOrList === 0) ? 'greenw':'darkblue'" @click="thOrList=0; saveListParam()" title="Mosaic">
            <font-awesome-icon :icon="['fas', 'th']"></font-awesome-icon>
          </b-button>
          <!--
          <b-button style="margin-right:5px" :variant="(thOrList === 1) ? 'greenw':'darkblue'" @click="thOrList=1; saveListParam()" title="List">
            <font-awesome-icon :icon="['fas', 'list']"></font-awesome-icon>
          </b-button>
          -->
        </b-button-group>
      </b-col>

      <b-col cols="auto">
        <b-dropdown size="sm" style="z-index:3" id="dropdown-2" v-bind:text="numberPerPage + ' per page'" variant="greenw">
          <b-dropdown-item v-bind:class="numberPerPage === 12" @click="numberPerPage=12; currentPage = 1; getVideos()">12</b-dropdown-item>
          <b-dropdown-item v-bind:class="numberPerPage === 20" @click="numberPerPage=20; currentPage = 1; getVideos()">20</b-dropdown-item>
          <b-dropdown-item v-bind:class="numberPerPage === 50" @click="numberPerPage=50; currentPage = 1; getVideos()">50</b-dropdown-item>
          <b-dropdown-item v-bind:class="numberPerPage === 100" @click="numberPerPage=100; currentPage = 1; getVideos()">100</b-dropdown-item>
        </b-dropdown>
      </b-col>

      <b-col cols="auto">
        <b-button-group class="align-items-center">
          <b-button variant="mswarning" @click="updateVideoPluginList()" title="Refresh list">
            <font-awesome-icon :icon="['fas', 'film']"></font-awesome-icon> {{$ml.get('loadnewvideos')}}
          </b-button>
          &nbsp;
          <b-button variant="msstreamblue" @click="getVideos()" title="Refresh list">
            <font-awesome-icon :icon="['fas', 'sync']"></font-awesome-icon> {{$ml.get('refresh')}}
          </b-button>
        </b-button-group>
      </b-col>

    </b-row>

    <b-row class="justify-content-between">  
      <b-col md="auto">

        <div class="scrollmenu">
          <p style="margin: 2px 0px; font-size: 70%" v-text="$ml.get('selectsort')"></p>
        </div>

      <div class="scrollmenu" style="padding-bottom: 10px">
        <b-button size="sm" style="margin-left:0px; margin-right:2px" @click="changeActiveSort('videoIDMin')" :variant="(activeSort === 'videoIDMin') ? 'greenw':'darkblue'">
          {{$ml.get('title')}}
          <font-awesome-icon v-if="activeSort === 'videoIDMin' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon>
          <font-awesome-icon v-if="activeSort === 'videoIDMin' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('createdDate', -1)" :variant="(activeSort === 'createdDate') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'calendar-minus']"></font-awesome-icon> 
          {{$ml.get('creationdate')}} 
          <font-awesome-icon v-if="activeSort === 'createdDate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'createdDate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>    
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('currentNumberOfQualities', -1)" :variant="(activeSort === 'currentNumberOfQualities') ? 'greenw':'darkblue'">
          {{$ml.get('qnbr')}}
          <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'currentNumberOfQualities' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('hourview', -1)" :variant="(activeSort === 'hourview') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon>
          {{$ml.get('viewingtime')}}
          <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'hourview' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('concurrentUsers', -1)" :variant="(activeSort === 'concurrentUsers') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> 
          {{$ml.get('viewers')}}
          <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'concurrentUsers' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('meanTime', -1)" :variant="(activeSort === 'meanTime') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon>
          {{$ml.get('meanvd')}}
          <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'meanTime' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bestQualityPercent', -1)" :variant="(activeSort === 'bestQualityPercent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> 
          {{$ml.get('topq')}}
          <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'bestQualityPercent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('bitrate', -1)" :variant="(activeSort === 'bitrate') ? 'greenw':'darkblue'">
          &#x7E; {{$ml.get('bitrate')}}
          <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'bitrate' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('rebuff')" :variant="(activeSort === 'rebuff') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon>           
          {{$ml.get('rebuff')}}
          <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'rebuff' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('offload', -1)" :variant="(activeSort === 'offload') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> 
          {{$ml.get('eff')}}
          <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'offload' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('dataDelivered', -1)" :variant="(activeSort === 'dataDelivered') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> 
          {{$ml.get('dataout')}}
          <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'dataDelivered' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('totalMB_peer', -1)" :variant="(activeSort === 'totalMB_peer') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon>
          {{$ml.get('dataoutp')}}
          <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'totalMB_peer' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('energySaved', -1)" :variant="(activeSort === 'energySaved') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon> 
          {{$ml.get('energy')}}
          <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'energySaved' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('kwhSpent')" :variant="(activeSort === 'kwhSpent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> 
          {{$ml.get('KWh')}}
          <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'kwhSpent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('co2Spent')" :variant="(activeSort === 'co2Spent') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> 
          {{$ml.get('carbon')}}
          <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === -1" :icon="['fas', 'sort-numeric-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'co2Spent' && activeSortOrder === 1" :icon="['fas', 'sort-numeric-down']"></font-awesome-icon>
        </b-button>
        <b-button size="sm" style="margin-left:2px; margin-right:2px" @click="changeActiveSort('collections')" :variant="(activeSort === 'collections') ? 'greenw':'darkblue'">
          <font-awesome-icon :icon="['fas', 'tags']"></font-awesome-icon> 
          {{$ml.get('tags')}}
          <font-awesome-icon v-if="activeSort === 'collections' && activeSortOrder === -1" :icon="['fas', 'sort-alpha-up']"></font-awesome-icon> 
          <font-awesome-icon v-if="activeSort === 'collections' && activeSortOrder === 1" :icon="['fas', 'sort-alpha-down']"></font-awesome-icon>
        </b-button>
      </div>
    </b-col>
    </b-row>

    <b-row v-if="isGetInProgress" class="justify-content-center marginaltopsm">
      <fade-loader color="#f98e35" style="position: relative; width: 45px; height: 60px; margin: auto; text-align: center"></fade-loader>
    </b-row>

    <div class="scrollmenu">
      <p style="padding-bottom:2px; margin:0px; font-size: 70%" v-text="$ml.get('last24p')"></p>
    </div>


    <b-row v-if="videos.length !== undefined" class="align-items-center" style="margin: 5px 0px 5px 5px; font-size:14px">
    <p style="margin: 0px 0.3rem 0px 0px">
      &#8627; 
      {{$ml.get('selected')}} 
      {{nbrVideoSelected}} 
    </p>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateHideVideo()" title="Hide selected video">
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fa', 'eye-slash']" />
        </font-awesome-layers></small>
      </b-button>

    <b-button size="sm" :variant="(nbrVideoSelected > 0) ? 'emptyB':'emptyNoB'" :disabled="nbrVideoSelected < 1" @click="updateUnhideVideo()" title="Unhide selected video">
        <small><font-awesome-layers>
          <font-awesome-icon :icon="['fa', 'eye']" />
        </font-awesome-layers></small>
      </b-button>
    </b-row>

    <b-row class="align-items-center justify-content-between" style="margin: 5px 0px 5px 5px; font-size:14px">
      <b-col cols="auto">
        <b-form-checkbox v-model="seeHidden" @input="refreshManual"> <p style="cursor: pointer; margin-top:5px">{{$ml.get('showhidden')}}</p></b-form-checkbox>
      </b-col>
      <b-col cols="auto">
        <b-form-checkbox v-model="isRunningOnly" > <p style="cursor: pointer; margin-top:5px">{{$ml.get('showactiveonly')}}</p></b-form-checkbox>
      </b-col>
    </b-row>

    <b-row style="margin-top:0px">
      <div v-bind:class="{ 
        /*mycard2: (video.rebuff < 20 && !(video.error === true)),
        mycard: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
        mycard4: (video.rebuff >= 50 && !(video.error === true)),
        mycard5: (video.error === true || !video.hasOwnProperty('rebuff')),*/
        mycardLiveOn: (runningVideos.indexOf(video.videoID) !== -1),
        mycard2: (runningVideos.indexOf(video.videoID) === -1),
        noDisplay: (isRunningOnly && runningVideos.indexOf(video.videoID) === -1)
      }" class='col-lg-3 col-md-4 col-sm-6 col-12' v-for="video in videos" v-bind:key="video.videoID">

        <div style="margin-top: 8px">
          <b-row style="padding: 0px 15px">
            <div style="color: #ba0000" v-if="runningVideos.indexOf(video.videoID) !== -1">
              <font-awesome-icon :icon="['fas', 'video']" title="Active during the last 2min" />
              &nbsp;<small>{{$ml.get('activelast2min')}}</small>
            </div>
            <div v-if="runningVideos.indexOf(video.videoID) === -1">
              <font-awesome-icon :icon="['fas', 'film']" title="Inactive" />
            </div>
          </b-row>

            <b-row>
              <b-col cols=12 :title="video.videoID+'. Title of the video, corresponding to the videoID mentioned in the configQuanteec object'">
                <h6 style="margin: 3px 0px; border-bottom: 1px solid #2F90B0; border-radius:0; text-overflow: ellipsis; overflow: hidden; white-space: nowrap"><strong>{{video.videoID}}</strong></h6>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12" title="Author of the video, corresponding to your client ID">
                <p style="font-size:14px; margin-bottom: 10px; padding-bottom:5px; color: #2a5d77; text-overflow: ellipsis; overflow: hidden; white-space: nowrap" v-if="video.client && video.client !== ''">
                  {{$ml.get('by')}}
                  <strong> {{video.client}}</strong>
                </p>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="auto" v-for="collection in video.collections" v-bind:key="collection">
                <div :class="{'tag-not-selected': (selectedCollections.indexOf(collection) === -1 && exludedCollections.indexOf(collection) === -1), 'tag-selected': selectedCollections.indexOf(collection) > -1, 'tag-excluded': exludedCollections.indexOf(collection) > -1 }">
                  <span style="padding-left:10px;padding-right:10px">
                  {{collection}}</span>
                </div>
              </b-col>
            </b-row>

            <b-row class="justify-content-center">
              <div class="previewContainer" style="z-index:1">
                <b-img @click="openAnalyticsForVideo(video)" v-if="video.isLive && !video.thumbnailURL"  class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Thumbnail_live.png`)" @error="imgUrlAlt($event, video)" fluid></b-img>
                <b-img @click="openAnalyticsForVideo(video)" v-if="!video.isLive && !video.thumbnailURL" class="previewImg" style="object-fit:contain; cursor:pointer" :src="require(`@/../public/Thumbnail_vod.png`)" @error="imgUrlAlt($event, video)" fluid></b-img>
                <b-img @click="openAnalyticsForVideo(video)" v-if="video.thumbnailURL" class="previewImg" style="object-fit:contain; cursor:pointer" :src="video.thumbnailURL" @error="imgUrlAlt($event, video)" fluid></b-img>
                <div style="position:absolute; z-index:2; left: 5px; top: 3px">
                  <b-form-checkbox v-model="video._isSelected" @input="updateSelectedNumber"></b-form-checkbox>
                </div>
              </div>
            </b-row>

            <b-row class="justify-content-around">
              <small style="font-size:12px; margin:8px" title="Video creation date">
                <font-awesome-icon :icon="['fas', 'calendar-minus']" /> 
                {{ video._created }}
              </small>
            </b-row>

            <b-row class="justify-content-around align-items-center m-1 p-1" style="border-top:1px solid #2a5d77; border-bottom:1px solid #2a5d77; font-size:small" title="Only qualities that have been viewed last 24h are shown here">
              {{$ml.get('qnbr')}}: 
              <b-badge v-if="video.isSD" style="font-size:11px; background-color:#ba0000; padding:5px" title="SD quality" >SD</b-badge>
              <b-badge v-if="video.isHD" style="font-size:11px; background-color:#ba008f; padding:5px" title="HD quality" >HD</b-badge>
              <b-badge v-if="video.isFullHD" style="font-size:11px; background-color:#2F90B0; padding:5px" title="Full HD 1080p quality" >1080p</b-badge>
              <b-badge v-if="video.is2K" style="font-size:11px; background-color:#aac8d4; padding:5px" title="2K 1440p quality" >2K</b-badge>
              <b-badge v-if="video.is4K" style="font-size:11px; background-color:rgb(20, 191, 152); padding:5px" title="4K 2160p quality" >4K</b-badge>
            </b-row>

            <b-row class="justify-content-between align-items-center m-1 p-1">
              <small title="Total viewing time"><font-awesome-icon :icon="['fas', 'hourglass-end']"></font-awesome-icon> {{video.hourview_unit || '0s'}}</small>
              <small title="Maximum concurrent viewers over the period"><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon> {{video.concurrentUsers || '0'}}</small>
              <small title="Mean viewing time"><font-awesome-icon :icon="['fas', 'stopwatch']"></font-awesome-icon> {{video.meanTime_unit || '0s'}}</small>
            </b-row>

            <b-row class="justify-content-between align-items-center m-1 p-1">
              <small title="Best quality % "><font-awesome-icon :icon="['fas', 'signal']"></font-awesome-icon> {{video.bestQualityPercent_unit || '100%'}}</small>
              <small title="Average bitrate ">&#x7E; {{video.bitrate_unit || '0kbps'}}</small>
              <small title="Rebuffering % " v-bind:class="{
                green: (video.rebuff < 20 && !(video.error === true)),
                orange: (video.rebuff >= 20 && video.rebuff < 50 && !(video.error === true)),
                red: (video.rebuff >= 50 && !(video.error === true)),
                black: (video.error === true || !video.hasOwnProperty('rebuff')),
                }"
              >
                <font-awesome-icon :icon="['fas', 'spinner']"></font-awesome-icon> {{video.rebuff_unit || '0%'}}
              </small>
            </b-row>
  
            <b-row class="justify-content-between align-items-center m-1 p-1">
              <small title="Efficiency % "><font-awesome-icon :icon="['fas', 'reply-all']" transform="rotate-120"></font-awesome-icon> {{video.offload_unit || '0'}}</small>
              <small title="Data delivered "><font-awesome-icon :icon="['fas', 'database']"></font-awesome-icon> {{video.dataDelivered_unit || '0'}}</small>
              <small title="Data delivered by peers "><font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon> {{video.totalMB_peer_unit || '0'}}</small>
            </b-row>

            <b-row class="justify-content-between align-items-center m-1 p-1">
              <small title="Energy saved % "><font-awesome-icon :icon="['fas', 'leaf']"></font-awesome-icon> {{video.energySaved_unit || '0%'}}</small>
              <small title="KWh spent "><font-awesome-icon :icon="['fas', 'plug']"></font-awesome-icon> {{video.kwhSpent_unit || '0wh'}}</small>
              <small title="CO2 spent "><font-awesome-icon :icon="['fas', 'fire']"></font-awesome-icon> {{video.co2Spent_unit || '0g'}}</small>
            </b-row>

            <div style="padding-top:10px; border-top:1px solid #2a5d77" />

            <b-row v-if="!video._modifyTags" class="pointerEltVideo" @click="startModifyTags(video)" title="Video tags, click to modify">
              <b-col cols="12">
                <p v-if="video.tags && video.tags !== ''" style="margin:0px">
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
                  </font-awesome-layers>
                  &nbsp;{{video.tags.split('|:|').join(' ')}}</small>
                </p>
                <p style="margin:0px" v-else>
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180"></font-awesome-icon>
                    <font-awesome-icon :icon="['fas', 'tags']" transform="shrink-2"></font-awesome-icon>
                  </font-awesome-layers> 
                  &nbsp;-</small>
                </p>
              </b-col>
            </b-row>

            <b-row v-if="video._modifyTags" class="align-items-center" title="Video tags modification">
              <b-col cols="10">
                <tags-input style="font-size:85%" element-id="tags" 
                v-model="video._tags" @tags-updated="updateTags(video)" placeholder="Add a Tag and press Enter"></tags-input>
              </b-col>
              <b-col cols="2" style="padding:0px; margin-left:-10px">
                <b-button variant="empty" @click="endModifyTags(video)" type=submit>
                  <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
                </b-button>
                <b-button variant="empty" @click="videos = videos.splice(0); video._modifyTags=false; cancelModifyTags(video)">
                  <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
                </b-button>
              </b-col>
            </b-row>

            <b-row v-if="!video._modifyDescription" class="pointerEltVideo" @click="video._modifyDescription = !video._modifyDescription; video._desc=video.description; videos=videos.splice(0)" style="margin-top:10px" title="Video description, click to modify">
              <b-col cols="12">
                <p style="margin-bottom:5px" v-if="video.description && video.description !== ''">
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;{{video.description}}</small>
                </p>
                <p style="margin-bottom:5px" v-else>
                  <small><font-awesome-layers>
                    <font-awesome-icon :icon="['fas', 'file-alt']" />
                    <font-awesome-icon :icon="['fas', 'pencil-alt']" transform="shrink-4 up-10 right-6 flip-v rotate-180" />
                  </font-awesome-layers>
                  &nbsp;-</small>
                </p>
              </b-col>
            </b-row>

            <b-row class="align-items-center" v-if="video._modifyDescription" title="Video description modification">
              <b-col cols="10">
                <b-form @submit.prevent="updateDescription(video)">
                  <b-form-textarea
                  id="textarea"
                  v-model="video._desc"
                  placeholder="Write description here"
                  rows="1"
                  max-rows="2"
                  style="font-size:85%; margin-top:5px; margin-bottom:5px"
                  ></b-form-textarea>
                </b-form>
              </b-col>
              <b-col cols="2" style="padding:0px; margin-left:-10px">
                <b-button variant="emptyB" @click="updateDescription(video);">
                  <small><font-awesome-icon style="color:#14BF98" :icon="['fas', 'check']" /></small>
                </b-button>
                <b-button variant="emptyB" @click="video._modifyDescription = false; video._desc=video.description; videos = videos.splice(0)">
                  <small><font-awesome-icon style="color:red" :icon="['fas', 'times']" /></small>
                </b-button>
              </b-col>
            </b-row>

            <div style="padding-top:10px; border-top:1px solid #2a5d77" />

            <p style="text-align:center;" class="marginaltopsm" v-if="video.isDefaultAuthorizations"><span class="defaultAuthBadge">{{$ml.get('pluginvideobound')}}</span></p>
            <p style="text-align:center;" class="marginaltopsm" v-if="video.isHidden"><span class="hiddenAuthBadge">This video is usually hidden</span></p>


            <b-row>
              <b-col cols="auto" >
                <b-form-group style="margin-bottom:10px">
                  <b-form-checkbox size="sm" id="isAuth" disabled v-model="video.authorizedStream" @change="updateAuthorizedStreams(video)" switch >
                    &nbsp;
                    <span style="font-size:small">
                      <font-awesome-icon v-if="video.authorizedStream" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      <font-awesome-icon v-if="!video.authorizedStream" style="color: red" :icon="['fas', 'minus-circle']" />
                      {{
                      video.authorizedStream
                        ? 
                          $ml.get("pluginvideoisauthst")
                        : 
                          $ml.get("pluginvideoisnotauthst")
                      }}
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.authorizedIPs.length>0 && video.isAuthorizedIPs === 'IPAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('pluginvideoauthip')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(authIP, authIPIdx) in video.authorizedIPs" v-bind:key="authIPIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{authIP}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.unauthorizedIPs.length>0 && video.isAuthorizedIPs === 'IPNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                {{$ml.get('pluginvideounauthip')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(notAuthIP, notAuthIPIdx) in video.unauthorizedIPs" v-bind:key="notAuthIPIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{notAuthIP}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.authorizedSubdomains && video.authorizedSubdomains.length >0 && video.isAuthorizedSubdomains === 'SubdomainAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('pluginvideoauthsubdomain')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(authSub, authSubIdx) in video.authorizedSubdomains" v-bind:key="authSubIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{authSub}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.unauthorizedSubdomains && video.unauthorizedSubdomains.length >0 &&  video.isAuthorizedSubdomains === 'SubdomainNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
               {{$ml.get('pluginvideounauthsubdomain')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(notAuthSub, notAuthSubIdx) in video.unauthorizedSubdomains" v-bind:key="notAuthSubIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{notAuthSub}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.authorizedCountries.length>0 && video.isAuthorizedCountries === 'countriesAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('pluginvideoauthcountry')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(authC, authCIdx) in video.authorizedCountries" v-bind:key="authCIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{authC}}
                  </span>
                </b-row>
              </b-col>
            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.unauthorizedCountries.length>0 && video.isAuthorizedCountries === 'countriesNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                {{$ml.get('pluginvideounauthcountry')}}&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(notAuthC, notAuthCIdx) in video.unauthorizedCountries" v-bind:key="notAuthCIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{notAuthC}}
                  </span>
                </b-row>
              </b-col>

            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.whitelistedWebsite.length>0 && video.isAuthorizedWebsites === 'websitesAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
                {{$ml.get('cdnwhitelistedwebsites')}}:&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(whiteW, whiteWIdx) in video.whitelistedWebsite" v-bind:key="whiteWIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{whiteW}}
                  </span>
                </b-row>
              </b-col>

            </b-row>

            <b-row class="align-items-center mb-3" v-if="video.blacklistedWebsite.length>0 && video.isAuthorizedWebsites === 'websitesNotAuthorized'">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
                {{$ml.get('cdnblacklistedwebsites')}}:&nbsp;
              </b-col>
              <b-col cols="12" style="font-size:small">
                <b-row v-for="(blackW, blackWIdx) in video.blacklistedWebsite" v-bind:key="blackWIdx" class="justify-content-center m-1" >
                  <span style="font-size:small">
                    {{blackW}}
                  </span>
                </b-row>
              </b-col>
              
            </b-row>

            <b-row>
              <b-col cols="auto" >
                <b-form-group style="margin-bottom:0px">
                  <b-form-checkbox size="sm" disabled id="isVPN" v-model="video.authorizedVPNs" @change="updateAuthorizedVPNs(video)" switch >
                    &nbsp;
                    <span style="font-size:small">
                      <font-awesome-icon v-if="video.authorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
                      <font-awesome-icon v-if="!video.authorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
                      {{
                      video.authorizedVPNs
                        ? $ml.get('videopluginvpn')
                        : $ml.get('videopluginnotvpn')
                      }}
                      <span v-if="!video.authorizedVPNs && video.authorizedVPNsList.length === 0 ">
                        {{$ml.get('smallnone')}}
                      </span>
                    </span>
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>

            <div v-if="!video.authorizedVPNs">
            <b-row v-for="(authVPN, authVPNIdx) in video.authorizedVPNsList" v-bind:key="authVPNIdx" class="justify-content-center m-1" >
              <span style="font-size:small">
                {{authVPN}}
              </span>
            </b-row>
            </div>

            <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

            <b-row class="mb-2 align-items-center">
              <b-col cols="12" style="font-size:small">
                <font-awesome-icon :icon="['fas', 'cogs']" />
                {{$ml.get('pluginvideoice')}}
                <span v-if="video.ICEConfig === 'QUANTEEC'">
                  <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:15px" />
                  QUANTEEC
                </span>
                <span v-if="video.ICEConfig === 'local'">
                  {{$ml.get('pluginvideolocalnet')}}
                </span>
                <span v-if="video.ICEConfig === 'custom'">
                  {{$ml.get('custom')}} ({{video.customIce.length}})
                </span>
              </b-col>
            </b-row>

            <b-row v-for="(ice, indexIce) in video.customIce" v-bind:key="ice._id" class="mr-1 ml-1 mb-1" style="font-size:small">
              {{(ice.credential !== undefined ? 'TURN: ' : 'STUN: ')}}&nbsp;
              <div v-for="(url, idx) in ice.urls" v-bind:key="idx">
                {{ice.urls[idx]}} &nbsp;
              </div>
            </b-row>

            <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

            <b-row class="align-items-center justify-content-around mb-3">
              <b-col cols="auto">
                <b-btn size="sm" variant="mswarning" @click="selectedVideo = video; showModal('authorizations')" >{{$ml.get('modify')}}</b-btn>
              </b-col>
            </b-row>

        </div>

      </div>
    </b-row>

</b-container>

  <b-pagination 
    size="sm"
    v-if="videos.length !== undefined && videos.length > 2" 
    align="center" 
    :limit="8" 
    :total-rows="realTotalNumberOfPage" 
    v-model="currentPage" 
    :per-page="1" 
    first-number last-number 
    @input="getVideos()">
  </b-pagination>

  <b-row v-if="realTotalNumberOfPage > 10 && videos.length !== undefined && videos.length > 2" class="justify-content-center" style="margin-right:0px">
    <b-col cols="10" xs="8" md="8" lg="3">
      <b-form @submit.prevent="currentPage = goPage">
        <b-form-group >
          <b-input-group size="sm" prepend="Go to page:">
            <b-form-input type="number" min="1" v-model="goPage"></b-form-input>
            <b-input-group-append><b-button variant="db-sb" @click="currentPage = goPage">Go</b-button></b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-form>
    </b-col>
  </b-row>

  <a id="bottom"></a>

  <b-modal 
    id="authorizations"
    ref="authorizations"
    title="Video configuration"
    size="lg"
    @show="openModalAuthorization"
    no-close-on-backdrop
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">

     <b-card-body>

      <b-row class="justify-content-center mb-2">
        <h6>
          {{$ml.get('pluginvideothumbnail')}}
        </h6>
      </b-row>

      <b-row>
        <b-form-input style="font-size:small; margin:0px 20px" v-model="selectedVideo._thumbnailURL" :placeholder="$ml.get('pluginvideoenterurlthumb')"></b-form-input>
      </b-row>

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

      <b-row class="justify-content-center mb-3">
        <h6>
          {{$ml.get('pluginvideoauthorizations')}}
        </h6>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" v-model="authorizedStream" switch >
          &nbsp;
          <font-awesome-icon v-if="authorizedStream" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!authorizedStream" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            authorizedStream
            ? $ml.get('pluginvideoisauthorized')
            : $ml.get('pluginvideoisnotauthorized')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row class="justify-content-center mb-1" style="font-size:10px">
        <p v-if="authorizedStream">{{$ml.get('pluginvideostreamed')}}</p>
        <p v-if="!authorizedStream">{{$ml.get('pluginvideonotstreamed')}}</p>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedIPs" name="some-radiosIP" value="IPAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthip2')}}
          </b-form-radio>        
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedIPs" name="some-radiosIP" value="IPNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthip2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop5')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop6')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaIP" :disabled="isAuthorizedIPs === 'IPNotAuthorized'" style="font-size:small"
          v-model="selectedVideo._authorizedIPsTags" placeholder="IP address + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuIP" :disabled="isAuthorizedIPs === 'IPAuthorized'" style="font-size:small"
          v-model="selectedVideo._unauthorizedIPsTags" placeholder="IP address + Enter"></tags-input>
      </b-row>



      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedSubdomains" name="some-radiosSubdomain" value="SubdomainAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthsubdomaine2')}}
          </b-form-radio>        
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedSubdomains" name="some-radiosSubdomain" value="SubdomainNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthsubdomain2')}}
          </b-form-radio>
        </b-col>
      </b-row>

      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideosubdomainauth')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideosubdomainunauth')"></p>
      </b-row>

      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaSubdomaine" :disabled="isAuthorizedSubdomains === 'SubdomainNotAuthorized'" style="font-size:small"
          v-model="selectedVideo._authorizedSubdomainsTags" placeholder="Subdomain address + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuSubdomaine" :disabled="isAuthorizedSubdomains === 'SubdomainAuthorized'" style="font-size:small"
          v-model="selectedVideo._unauthorizedSubdomainsTags" placeholder="Subdomain address + Enter"></tags-input>
      </b-row>

      

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedCountries"  name="some-radiosC" value="countriesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthcountry2')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedCountries"  name="some-radiosC" value="countriesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthcountry2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop7')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop8')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaC" :disabled="isAuthorizedCountries === 'countriesNotAuthorized'" style="font-size:small"
          v-model="selectedVideo._authorizedCountriesTags" placeholder="Country + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="taguCs" :disabled="isAuthorizedCountries === 'countriesAuthorized'" style="font-size:small"
          v-model="selectedVideo._unauthorizedCountriesTags" placeholder="Country + Enter"></tags-input>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedWebsites"  name="some-radiosW" value="websitesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideowhitewb')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="isAuthorizedWebsites"  name="some-radiosW" value="websitesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideoblackwb')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop9')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop10')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaW" :disabled="isAuthorizedWebsites === 'websitesNotAuthorized'" style="font-size:small"
          v-model="selectedVideo._whitelistedWebsiteTags" placeholder="Website + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuW" :disabled="isAuthorizedWebsites === 'websitesAuthorized'" style="font-size:small"
          v-model="selectedVideo._blacklistedWebsiteTags" placeholder="Website + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" id="isStreamingModal" v-model="authorizedVPNs" switch >
          &nbsp;
          <font-awesome-icon v-if="authorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!authorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            authorizedVPNs
            ? $ml.get('pluginvideoisvpn')
            : $ml.get('pluginvideoisnotvpn')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row v-if="!authorizedVPNs" class="justify-content-center mb-4">
        <tags-input element-id="tags" style="font-size:small; width:250px" 
          v-model="selectedVideo._authorizedVPNsTags" placeholder="IP address + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:2rem 5rem"></b-row>

      <b-row class="justify-content-center mb-2">
        <h6>
          <font-awesome-icon :icon="['fas', 'cogs']" />&nbsp; {{$ml.get('pluginvideoiceconf')}}
        </h6>
      </b-row>
      <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
        <b-form-group>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfig"  name="some-radios" value="QUANTEEC"></b-form-radio>
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:15px" />
            &nbsp;{{$ml.get('pluginvideodefault')}}
          </b-row>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfig"  name="some-radios" value="local"></b-form-radio>
            {{$ml.get('pluginvideolocalnet')}}
          </b-row>
          <b-row class="align-items-center">
            <b-form-radio v-model="ICEConfig"  name="some-radios" value="custom"></b-form-radio>
            {{$ml.get('pluginvideoicecustom')}}
          </b-row>
        </b-form-group>
      </b-row>

      <div v-if="ICEConfig === 'custom'">

<!--
        <tags-input element-id="tagsSTUN" style="font-size:small"
          v-model="ice.urls" placeholder="STUN @ + Enter"></tags-input>

        <tags-input element-id="tagsTURN" style="font-size:small"
          v-model="ice.urls" placeholder="TURN @ + Enter"></tags-input>
-->

            <b-row class="align-items-center justify-content-around m-2" style="font-size:small"> 
              <b-btn size="sm" variant="msstreamblue" @click="addSTUN">{{$ml.get('pluginvideoaddstun')}}</b-btn>
              <b-btn size="sm" variant="msstreamblue" @click="addTURN">{{$ml.get('pluginvideoaddturn')}}</b-btn>
            </b-row>

          <div v-for="(ice, indexIce) in customIce" style="margin:0.5rem 0rem; padding:0.25rem; padding-bottom:0.5rem; border: 1px solid #2a5d77; border-radius:0.25rem" v-bind:key="ice._id">
              <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
                {{(ice.credential !== undefined ? 'TURN' : 'STUN')}}&nbsp; 
                <b-button size="sm" variant="emptyB" @click="removeICE(indexIce)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
              </b-row>
              <b-row v-for="(url, idx) in ice.urls" v-bind:key="idx" class="align-items-center ml-1">
                <b-form-group 
                style="margin:2px 0px"
                label-cols-sm="3"
                content-cols-sm
                label-size="sm" 
                :label="'URL ' + Math.round(idx + 1) + ':'" 
                :label-for="'iceUrl' + ice._id + idx">
                  <b-form-input size="sm" v-model="ice.urls[idx]" :id="'iceUrl' + ice._id + idx"></b-form-input>
                </b-form-group>
                <b-button variant="emptyB" v-if="ice.urls.length > 1" size="sm" @click="removeUrl(ice, idx)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
                <b-button style="text-align:center" v-if="idx === ice.urls.length - 1" size="sm" variant="emptyB" @click="addUrl(ice)"><font-awesome-icon style="color:#2a5d77" :icon="['fas', 'plus']"></font-awesome-icon></b-button>
              </b-row>

            <b-row class="align-items-center ml-1">
              <b-form-group 
                  style="margin:2px 0px"
                  class="justify-content-center"
                  label-cols-sm="4"
                  label-size="sm" 
                  v-if="ice.username !== undefined" 
                  label="Username:" 
                  label-for="iceUsername">
                <b-form-input size="sm" v-model="ice.username" id="iceUsername"></b-form-input>
              </b-form-group>
            </b-row>
            <b-row class="align-items-center ml-1">
            <b-form-group 
                  style="margin:2px 0px"
                  label-cols-sm="4"
                  label-size="sm"             
                  v-if="ice.credential !== undefined" 
                  label="Password:" 
                  label-for="iceCredential">              
              <b-input-group>
                <b-form-input size="sm" :type="ice._showCredential" v-model="ice.credential" id="iceCredential"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="ice._showCredential === 'password'" variant="emptyB" @click="ice._showCredential = 'text'"><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon></b-button>
                    <b-button v-if="ice._showCredential === 'text'" variant="emptyB" @click="ice._showCredential = 'password'"><font-awesome-icon :icon="['fas', 'eye-slash']"></font-awesome-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-row>
          </div>
      </div>      

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

      <b-row class="justify-content-around mt-1">
        <b-button size="sm" @click="updateAuthorization(); hideModal('authorizations')" variant="mswarning">
          <font-awesome-icon icon="check" />
          {{$ml.get('pluginvideovalidate')}}
        </b-button>
        <b-button size="sm" @click="resetDefaultAuthorization(); hideModal('authorizations')" variant="mswarning">
          <font-awesome-icon icon="check" />
          {{$ml.get('pluginvideoresetdefault')}}
        </b-button>
        <b-button size="sm" @click="resetModalAuthorization(); hideModal('authorizations')" variant="quanteeclg">
          <font-awesome-icon style="color:red" icon="times" />
          {{$ml.get('cancel')}}
        </b-button>
      </b-row>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal 
    id="authorizationsCollection"
    ref="authorizationsCollection"
    title="Collection configuration"
    @show="openCollectionAuthorization()"
    no-close-on-backdrop
    hide-footer
  >
   <b-card border-variant="msstream" no-body style="margin-top:0px; margin-bottom:20px">

     <b-card-body>

      <b-row class="justify-content-center mb-2">
        <h6>
          {{$ml.get('pluginvideothumbnail')}}
        </h6>
      </b-row>

      <b-row>
        <b-form-input style="font-size:small; margin:0px 20px" v-model="collectionAuth._thumbnailURL" :placeholder="$ml.get('pluginvideoenterurlthumb')"></b-form-input>
      </b-row>

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

      <b-row class="justify-content-center mb-3">
        <h6>
          {{$ml.get('pluginvideoauthorizations')}}
        </h6>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" v-model="collectionAuth.authorizedStream" switch >
          &nbsp;
          <font-awesome-icon v-if="collectionAuth.authorizedStream" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!collectionAuth.authorizedStream" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            collectionAuth.authorizedStream
            ? $ml.get('pluginvideoisauthorized')
            : $ml.get('pluginvideoisnotauthorized')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row class="justify-content-center mb-1" style="font-size:10px">
        <p v-if="collectionAuth.authorizedStream">{{$ml.get('pluginvideostreamed')}}</p>
        <p v-if="!collectionAuth.authorizedStream">{{$ml.get('pluginvideonotstreamed')}}</p>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedIPs" name="some-radiosIP" value="IPAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthip2')}}
          </b-form-radio>        
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedIPs" name="some-radiosIP" value="IPNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthip2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop5')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop6')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaIP" :disabled="collectionAuth.isAuthorizedIPs === 'IPNotAuthorized'" style="font-size:small"
          v-model="collectionAuth._authorizedIPsTags" placeholder="IP address + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuIP" :disabled="collectionAuth.isAuthorizedIPs === 'IPAuthorized'" style="font-size:small"
          v-model="collectionAuth._unauthorizedIPsTags" placeholder="IP address + Enter"></tags-input>
      </b-row>


      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedCountries"  name="some-radiosC" value="countriesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideoauthcountry2')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedCountries"  name="some-radiosC" value="countriesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideounauthcountry2')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop7')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop8')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaC" :disabled="collectionAuth.isAuthorizedCountries === 'countriesNotAuthorized'" style="font-size:small"
          v-model="collectionAuth._authorizedCountriesTags" placeholder="Country + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="taguCs" :disabled="collectionAuth.isAuthorizedCountries === 'countriesAuthorized'" style="font-size:small"
          v-model="collectionAuth._unauthorizedCountriesTags" placeholder="Country + Enter"></tags-input>
      </b-row>

      <b-row class="align-items-center justify-content-around">
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedWebsites"  name="some-radiosW" value="websitesAuthorized">
            <font-awesome-icon style="color: #14BF98" :icon="['fas', 'check-circle']" />
            &nbsp;{{$ml.get('pluginvideowhitewb')}}
          </b-form-radio>
        </b-col>
        <b-col cols="2" style="font-size:small; text-align:center">
          - {{$ml.get('or')}} -
        </b-col>
        <b-col cols="col-md-5">
          <b-form-radio size="sm" v-model="collectionAuth.isAuthorizedWebsites"  name="some-radiosW" value="websitesNotAuthorized">
            <font-awesome-icon style="color: red" :icon="['fas', 'minus-circle']" />
            &nbsp;{{$ml.get('pluginvideoblackwb')}}
          </b-form-radio>
        </b-col>
      </b-row>
      <b-row class="align-items-center">
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop9')"></p>
        <p class="col-md-6" style="font-size:10px; margin-bottom:8px" v-html="$ml.get('pluginvideop10')"></p>
      </b-row>
      <b-row class="justify-content-around align-items-center mb-4">
        <tags-input class="col-md-6" element-id="tagsaW" :disabled="isAuthorizedWebsites === 'websitesNotAuthorized'" style="font-size:small"
          v-model="collectionAuth._whitelistedWebsiteTags" placeholder="Website + Enter"></tags-input>
        <tags-input class="col-md-6" element-id="tagsuW" :disabled="isAuthorizedWebsites === 'websitesAuthorized'" style="font-size:small"
          v-model="collectionAuth._blacklistedWebsiteTags" placeholder="Website + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center">
        <b-form-checkbox size="sm" id="isStreamingModal" v-model="collectionAuth.authorizedVPNs" switch >
          &nbsp;
          <font-awesome-icon v-if="collectionAuth.authorizedVPNs" style="color: #14BF98" :icon="['fas', 'check-circle']" />
          <font-awesome-icon v-if="!collectionAuth.authorizedVPNs" style="color: red" :icon="['fas', 'minus-circle']" />
          {{
            collectionAuth.authorizedVPNs
            ? $ml.get('pluginvideoisvpn')
            : $ml.get('pluginvideoisnotvpn')
          }}
        </b-form-checkbox>
      </b-row>
      <b-row v-if="!collectionAuth.authorizedVPNs" class="justify-content-center mb-4">
        <tags-input element-id="tags" style="font-size:small; width:250px" 
          v-model="collectionAuth._authorizedVPNsTags" placeholder="IP address + Enter"></tags-input>
      </b-row>

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:2rem 5rem"></b-row>

      <b-row class="justify-content-center mb-2">
        <h6>
          <font-awesome-icon :icon="['fas', 'cogs']" />&nbsp; {{$ml.get('pluginvideoiceconf')}}
        </h6>
      </b-row>
      <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
        <b-form-group>
          <b-row class="align-items-center">
            <b-form-radio v-model="collectionAuth.ICEConfig"  name="some-radios" value="QUANTEEC"></b-form-radio>
            <b-img fluid :src="require(`@/assets/logo.svg`)" style="max-height:15px" />
            &nbsp;{{$ml.get('pluginvideodefault')}}
          </b-row>
          <b-row class="align-items-center">
            <b-form-radio v-model="collectionAuth.ICEConfig"  name="some-radios" value="local"></b-form-radio>
            {{$ml.get('pluginvideolocalnet')}}
          </b-row>
          <!--<b-row class="align-items-center">
            <b-form-radio v-model="collectionAuth.ICEConfig"  name="some-radios" value="custom"></b-form-radio>
            {{$ml.get('pluginvideoicecustom')}}
          </b-row>-->
        </b-form-group>
      </b-row>
      <!-- TODO Collection custom ICE -->
      <!--<div v-if="collectionAuth.ICEConfig === 'custom'">

            <b-row class="align-items-center justify-content-around m-2" style="font-size:small"> 
              <b-btn size="sm" variant="msstreamblue" @click="addSTUN">{{$ml.get('pluginvideoaddstun')}}</b-btn>
              <b-btn size="sm" variant="msstreamblue" @click="addTURN">{{$ml.get('pluginvideoaddturn')}}</b-btn>
            </b-row>

          <div v-for="(ice, indexIce) in customIce" style="margin:0.5rem 0rem; padding:0.25rem; padding-bottom:0.5rem; border: 1px solid #2a5d77; border-radius:0.25rem" v-bind:key="ice._id">
              <b-row class="justify-content-center align-items-center mb-1" style="font-size:small">
                {{(ice.credential !== undefined ? 'TURN' : 'STUN')}}&nbsp; 
                <b-button size="sm" variant="emptyB" @click="removeICE(indexIce)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
              </b-row>
              <b-row v-for="(url, idx) in ice.urls" v-bind:key="idx" class="align-items-center ml-1">
                <b-form-group 
                style="margin:2px 0px"
                label-cols-sm="3"
                content-cols-sm
                label-size="sm" 
                :label="'URL ' + Math.round(idx + 1) + ':'" 
                :label-for="'iceUrl' + ice._id + idx">
                  <b-form-input size="sm" v-model="ice.urls[idx]" :id="'iceUrl' + ice._id + idx"></b-form-input>
                </b-form-group>
                <b-button variant="emptyB" v-if="ice.urls.length > 1" size="sm" @click="removeUrl(ice, idx)"><font-awesome-icon style="color:red" :icon="['fas', 'times']"></font-awesome-icon></b-button>
                <b-button style="text-align:center" v-if="idx === ice.urls.length - 1" size="sm" variant="emptyB" @click="addUrl(ice)"><font-awesome-icon style="color:#2a5d77" :icon="['fas', 'plus']"></font-awesome-icon></b-button>
              </b-row>

            <b-row class="align-items-center ml-1">
              <b-form-group 
                  style="margin:2px 0px"
                  class="justify-content-center"
                  label-cols-sm="4"
                  label-size="sm" 
                  v-if="ice.username !== undefined" 
                  label="Username:" 
                  label-for="iceUsername">
                <b-form-input size="sm" v-model="ice.username" id="iceUsername"></b-form-input>
              </b-form-group>
            </b-row>
            <b-row class="align-items-center ml-1">
            <b-form-group 
                  style="margin:2px 0px"
                  label-cols-sm="4"
                  label-size="sm"             
                  v-if="ice.credential !== undefined" 
                  label="Password:" 
                  label-for="iceCredential">              
              <b-input-group>
                <b-form-input size="sm" :type="ice._showCredential" v-model="ice.credential" id="iceCredential"></b-form-input>
                  <b-input-group-append>
                    <b-button v-if="ice._showCredential === 'password'" variant="emptyB" @click="ice._showCredential = 'text'"><font-awesome-icon :icon="['fas', 'eye']"></font-awesome-icon></b-button>
                    <b-button v-if="ice._showCredential === 'text'" variant="emptyB" @click="ice._showCredential = 'password'"><font-awesome-icon :icon="['fas', 'eye-slash']"></font-awesome-icon></b-button>
                  </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-row>
          </div>
      </div>  -->    

      <b-row class="justify-content-center" style="border-top:1px solid #2a5d77; margin:1rem 5rem"></b-row>

      <b-row class="justify-content-around mt-1">
        <b-button size="sm" @click="updateCollectionAuthorization(); hideModal('authorizationsCollection')" variant="mswarning">
          <font-awesome-icon icon="check" />
          {{$ml.get('pluginvideovalidate')}}
        </b-button>
        <b-button size="sm" @click="openCollectionAuthorization(); hideModal('authorizationsCollection')" variant="quanteeclg">
          <font-awesome-icon style="color:red" icon="times" />
          {{$ml.get('cancel')}}
        </b-button>
      </b-row>
    </b-card-body>
   </b-card>
  </b-modal>

  <b-modal
    id="modifyThumbnail"
    ref="modifyThumbnail"
    title="Modify URL for the thumbnail"
    @show="openModalThumbnail"
    no-close-on-backdrop
  >
    
  </b-modal>

</div>
</template>

<script>
import FadeLoader from "vue-spinner/src/FadeLoader.vue";
let moment = require("moment");
import VideoService from "@/services/video.service";
import AnalyticsService from "@/services/analytics.service";
import PluginParamsService from "@/services/videoPluginParams.service.js"
var videoService = new VideoService();
var analyticsService = new AnalyticsService();
var pluginParamsService = new PluginParamsService();

import {v4 as uuidv4} from 'uuid';



export default {
  name: "VideoListPlugin",
  components: {
        FadeLoader,
  },
  data: function () {
    return {
      videos : [],
      runningVideos: [],
      isRunningOnly: false,
      clientView: this.$auth.getMyUser().roles.indexOf("admin") > -1
          ? this.$auth.getMyClientView() || this.$auth.getMyUser().client
          : this.$auth.getMyUser().client,
      //PAGE
      totalNumberOfPage: 1000000,
      realTotalNumberOfPage: 1000000,
      currentPage: 1,
      goPage: 1,
      numberPerPage: (this.$auth.getMyUser().client_infos && this.$auth.getMyUser().client_infos[0] && this.$auth.getMyUser().client_infos[0].defaultNumberPerPage) ? this.$auth.getMyUser().client_infos[0].defaultNumberPerPage : 20,
      lastGetWithPage: false,

      //SEARCH PARAM
      search: "",
      searchParameters: {},

      // LOADER
      isGetInProgress: false,
      timeoutSearch: null,
      timeoutSearchDuration: 2,

      // Advanced Filter :
      advancedFilter: false,
      oldAdvancedFilters: 'livevod',
      advancedFiltersDefault: ['live', 'vod'],
      advancedFilters: ['live', 'vod'],
      advancedFilterOptions: [
        { text: 'Live', value: 'live' },
        { text: 'VOD', value: 'vod' },
        /*{ text: 'Live archive', value: 'archive' },
        { text: 'Cut', value: 'cut' }*/
      ],
      qualityFilterOptions: [
        { text: 'SD', value: 'isSD' },
        { text: 'HD', value: 'isHD' },
        { text: 'FullHD', value: 'isFullHD' },
        { text: '2K', value: 'is2K' },
        { text: '4K', value: 'is4K' },
        { text: '8K', value: 'is8K' },

      ],
      qualityFiltersDefault:['isSD','isHD','isFullHD','is2K','is4K','is8K'],
      qualityFilters:['isSD','isHD','isFullHD','is2K','is4K','is8K'],
      oldQualityFilters:'isSDisHDisFullHDis2Kis4Kis8K',

      barOrCheck: false,

      //STAT
      numberOfVideos: 0,
      totalNumberOfVideos: 0,
      liveNumber: 0,
      vodNumber: 0,

      thOrList: 0,
      activeSort: "createdDate",
      activeSortOrder: -1,
      mySort: JSON.stringify({ createdDate: -1 }),

      /*
      authorizedStream:false,
      authorizedVPNs:false,
      authorizedIPs : [],
      unauthorizedIPs : [],
      authorizedCountries : [],
      unauthorizedCountries : [],
      whitelistedWebsite : [],
      blacklistedWebsite : [],
      authorizedVPNsList : [],
      ICEConfig : "QUANTEEC",
      */
      authIPaddr:"isAuthorizedIPs",
      authCountries: '1',
      authWebsites: '1',

      selectedVideo : {
        thumbnailURL:"",
        authorizedIPs:[],        
        unauthorizedIPs:[],
        authorizedSubdomains : [],
        unauthorizedSubdomains : [],
        authorizedCountries:[],
        unauthorizedCountries:[],
        whitelistedWebsite:[],
        blacklistedWebsite:[],
        authorizedVPNsList:[],
        _authorizedVPNsList:[],
        _authorizedIPs:[],
        _authorizedIPsTags: [],
        _unauthorizedIPs:[],
        _unauthorizedIPsTags:[],
        _authorizedSubdomains : [],
        _authorizedSubdomainsTags : [],
        _unauthorizedSubdomains : [],
        _unauthorizedSubdomainsTags : [],
        _authorizedCountries:[],
        _unauthorizedCountries:[],
        _whitelistedWebsite:[],
        _blacklistedWebsite:[],
      },
      authorizedVPNs:false,
      authorizedStream:false,
      isAuthorizedIPs:"IPAuthorized",
      isAuthorizedSubdomains:"SubdomainAuthorized",
      isAuthorizedCountries:"countriesAuthorized",
      isAuthorizedWebsites:"websitesAuthorized",
      ICEConfig:"QUANTEEC",
      customIce: [],
      collectionAuth: {
        id: "",
        _authorizedIPs: [],
        _authorizedIPsTags: [],
        _unauthorizedIPs: [],
        _unauthorizedIPsTags: [],
        _authorizedCountries: [],
        _authorizedCountriesTags: [],
        _unauthorizedCountries: [],
        _unauthorizedCountriesTags: [],
        _whitelistedWebsite: [],
        _whitelistedWebsiteTags: [],
        _blacklistedWebsite: [],
        _blacklistedWebsiteTags: [],
        isAuthorizedIPs: "IPAuthorized",
        isAuthorizedCountries: "countriesAuthorized",
        isAuthorizedWebsites: "websitesAuthorized",
        authorizedVPNs: true,
        authorizedStream: true,
        _authorizedVPNsList: [],
        _authorizedVPNsTags: [],
        ICEConfig: "QUANTEEC",
        modifyAuthorizedIPs: false,
        modifyUnauthorizedIPs: false,
        modifyAuthorizedCountries: false,
        modifyUnauthorizedCountries: false,
        modifyWhitelistedWebsites: false,
        modifyBlacklistedWebsites: false,
        modifyAuthorizedVPNs: false,
        customIce: [],
      },

      defaultParams:null,

      modifyAuthorizedIPs:false,
      modifyUnauthorizedIPs:false,
      modifyAuthorizedSubdomains:false,
      modifyUnauthorizedSubdomains:false,
      modifyAuthorizedCountries:false,
      modifyUnauthorizedCountries:false,
      modifyWhitelistedWebsites:false,
      modifyBlacklistedWebsites:false,
      modifyAuthorizedVPNs:false,

      isSelectAll:false,
      nbrVideoSelected:0,

      seeHidden:false,
      clientCollections:[],
      selectedCollections:[],
      exludedCollections:[],

    }
  },
      
  mounted: function () {
      let storageSearchInfos = this.getSearchParameters();
      let storageSort = this.getSortParameters();

      this.searchParameters = storageSearchInfos.searchParameters || this.searchParameters;
      this.search = storageSearchInfos.searchBar || this.search;

      this.activeSort = storageSort.sort || this.activeSort;
      this.activeSortOrder =
        storageSort.sortOrder !== null && storageSort.sortOrder !== undefined
          ? storageSort.sortOrder
          : this.activeSortOrder;
      this.mySort = JSON.stringify({ [this.activeSort]: this.activeSortOrder });

      if(storageSearchInfos.searchParameters && storageSearchInfos.searchParameters['$and'])
    {
      storageSearchInfos.searchParameters["$and"].forEach(param=>{
        if(Object.keys(param)[0] === "collections")
        {

          if(param.collections["$in"])
          {
            
            this.selectedCollections = param.collections["$in"]
          }

          if(param.collections["$nin"])
          {
            this.exludedCollections = param.collections["$nin"]
          }
        }
      })
    }

      this.getVideos(this.currentPage);
      this.getClientCollections().then(()=>{
        this.selectedCollections.forEach(collection=>{
          let currentCollection = document.getElementById("tag-"+collection)
          if(currentCollection){
          currentCollection.classList.add('tag-selected');
          currentCollection.classList.remove('tag-not-selected');
          }

        })

        this.exludedCollections.forEach(collection=>{

          let currentCollection = document.getElementById("tag-"+collection)
          if(currentCollection){
          currentCollection.classList.add('tag-excluded');
          currentCollection.classList.remove('tag-not-selected');
          }


        })
      })
  },
  computed:{
    defaultAdvancedFilters() {
      function areEqual(array1, array2) {
        if (array1.length === array2.length) {
          return array1.every(element => {
            if (array2.includes(element)) {
              return true;
            }

            return false;
          });
        }

        return false;
      }

      return areEqual(this.advancedFilters, this.advancedFiltersDefault);
    },
  },
  methods : {
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
    getRunningVideos() {
      analyticsService.getRunningVideos(this.clientView, this.$auth.token())
      .then(runningVideos => {
        this.runningVideos = runningVideos
      }).catch(err => {
        console.log(err);
      })
    },
    getVideos(page) {

      let filter = this.searchParameters;
      this.applyAdvancedFilters();

      let params;
      let params2;
      this.isGetInProgress = true;
      this.videos = [];
      this.numberOfVideos = 0;
      page = page || this.currentPage;

      params = {
        page: page,
        pagesize: this.numberPerPage,
        sort: this.mySort,
      };

      if (filter && filter !== "{}") {
        params.filter = filter;
      }
      if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
        var client = this.clientView;
        filter["client"] = client;
        console.log(filter);
        params2 = {
          filter: {
            client: client
          }
        }
      }

      //console.log(params)

      this.getNumberVideoPlatform();

      pluginParamsService.getDefaultParametersForClient(this.$auth.token(), params2)
      .then(defParams=>{
        this.defaultParams = defParams;
        this.defaultParams.result = this.defaultParams.customIce.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })
        this.getRunningVideos();
        videoService
        .getVideoListPlugin(this.$auth.token(), params )
        .then((videos) => {
          this.videos = videos._embedded;

          this.numberOfVideos = videos._size;
          this.viewMenu = {};
          this.totalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );
          this.realTotalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );

          this.isGetInProgress = false;
          //this.updateSelectedNumber();
          for (let video in this.videos) 
          {
            console.log(this.videos[video])
            //Si la vidéo utilise pas les authorisations par défaut ou que les autorisatins par défauts existent pas
            if(!this.videos[video].isDefaultAuthorizations)
            {
              this.videos[video]._modifyTags = false;
              this.videos[video]._created = moment(this.videos[video].createdDate).format("DD/MM/YY @HH:mm");
              
              if(!this.videos[video].authorizedIPs)
                this.videos[video].authorizedIPs = []

              if(!this.videos[video].unauthorizedIPs)
                this.videos[video].unauthorizedIPs = []
              
              if(!this.videos[video].authorizedSubdomains)
                this.videos[video].authorizedSubdomains = []

              if(!this.videos[video].unauthorizedSubdomains)
                this.videos[video].unauthorizedSubdomains = []
              

              if(!this.videos[video].authorizedCountries)
                this.videos[video].authorizedCountries = []

              if(!this.videos[video].unauthorizedCountries)
                this.videos[video].unauthorizedCountries = [] 
              
              if(!this.videos[video].whitelistedWebsite)
                this.videos[video].whitelistedWebsite = [] 

              if(!this.videos[video].blacklistedWebsite)
                this.videos[video].blacklistedWebsite = []   

              if(this.videos[video].authorizedStream === undefined || this.videos[video].authorizedStream === null)
                this.videos[video].authorizedStream = true;

              if(this.videos[video].authorizedVPNs === undefined || this.videos[video].authorizedVPNs === null)
                this.videos[video].authorizedVPNs = true;

              if(!this.videos[video].authorizedVPNsList)
                this.videos[video].authorizedVPNsList = []   

              if(!this.videos[video].ICEConfig)
                this.videos[video].ICEConfig = "QUANTEEC"

              if(!this.videos[video].isAuthorizedIPs)
                this.videos[video].isAuthorizedIPs = 'IPsAuthorized';

              if(!this.videos[video].isAuthorizedCountries)
                this.videos[video].isAuthorizedCountries = 'countriesAuthorized';

              if(!this.videos[video].isAuthorizedWebsites)
                this.videos[video].isAuthorizedWebsites = 'websitesAuthorized';

              if(!this.customIce)
                this.videos[video].customIce = [];
            }else{
              this.videos[video]._modifyTags = false;
              this.videos[video]._created = moment(this.videos[video].createdDate).format("DD/MM/YY @HH:mm");

              this.videos[video].authorizedIPs = this.defaultParams.authorizedIPs;
              this.videos[video].unauthorizedIPs = this.defaultParams.unauthorizedIPs;
              this.videos[video].authorizedSubdomains = this.defaultParams.authorizedSubdomains;
              this.videos[video].unauthorizedSubdomains = this.defaultParams.unauthorizedSubdomains;
              this.videos[video].authorizedCountries = this.defaultParams.authorizedCountries;
              this.videos[video].unauthorizedCountries = this.defaultParams.unauthorizedCountries;
              this.videos[video].whitelistedWebsite = this.defaultParams.whitelistedWebsite;
              this.videos[video].blacklistedWebsite = this.defaultParams.blacklistedWebsite;
              this.videos[video].authorizedVPNs = this.defaultParams.authorizedVPNs;
              this.videos[video].authorizedStream = this.defaultParams.authorizedStream;
              this.videos[video].authorizedVPNsList = this.defaultParams.authorizedVPNsList;
              this.videos[video].ICEConfig = this.defaultParams.ICEConfig;
              this.videos[video].customIce = this.defaultParams.result;
              this.videos[video].isAuthorizedIPs = this.defaultParams.isAuthorizedIPs;
              this.videos[video].isAuthorizedCountries = this.defaultParams.isAuthorizedCountries;
              this.videos[video].isAuthorizedWebsites = this.defaultParams.isAuthorizedWebsites;
            }
          };
        }).catch((e) => {
          this.isGetInProgress = false;
          //this.updateSelectedNumber();
        });

      }).catch(err=>{
                  videoService
        .getVideoListPlugin(this.$auth.token(), params, )
        .then((videos) => {
          this.videos = videos._embedded;
          this.numberOfVideos = videos._size;
          this.viewMenu = {};
          this.totalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );
          this.realTotalNumberOfPage = Math.ceil(
            this.numberOfVideos / this.numberPerPage
          );

          this.isGetInProgress = false;
          //this.updateSelectedNumber();
          for (let video in this.videos) 
          {
              this.videos[video]._modifyTags = false;
              this.videos[video]._created = moment(this.videos[video].createdDate).format("DD/MM/YY @HH:mm");
              
              if(!this.videos[video].authorizedIPs)
                this.videos[video].authorizedIPs = []

              if(!this.videos[video].unauthorizedIPs)
                this.videos[video].unauthorizedIPs = []
              
              if(!this.videos[video].authorizedCountries)
                this.videos[video].authorizedCountries = []

              if(!this.videos[video].unauthorizedCountries)
                this.videos[video].unauthorizedCountries = [] 
              
              if(!this.videos[video].whitelistedWebsite)
                this.videos[video].whitelistedWebsite = [] 

              if(!this.videos[video].blacklistedWebsite)
                this.videos[video].blacklistedWebsite = []   

              if(this.videos[video].authorizedStream === undefined || this.videos[video].authorizedStream === null)
                this.videos[video].authorizedStream = true;

              if(this.videos[video].authorizedVPNs === undefined || this.videos[video].authorizedVPNs === null)
                this.videos[video].authorizedVPNs = true;

              if(!this.videos[video].authorizedVPNsList)
                this.videos[video].authorizedVPNsList = []   

              if(!this.videos[video].ICEConfig)
                this.videos[video].ICEConfig = "QUANTEEC"

              if(!this.videos[video].isAuthorizedIPs)
                this.videos[video].isAuthorizedIPs = 'IPsAuthorized';

              if(!this.videos[video].isAuthorizedCountries)
                this.videos[video].isAuthorizedCountries = 'countriesAuthorized';

              if(!this.videos[video].isAuthorizedWebsites)
                this.videos[video].isAuthorizedWebsites = 'websitesAuthorized';
          };
        }).catch((e) => {
          this.isGetInProgress = false;
          //this.updateSelectedNumber();
        });
          this.isGetInProgress = false;
      })
    },
    getClientCollections(){
      return new Promise((resolve) => {
        videoService.getClientCollections(this.$auth.token(), this.clientView).then(res=>{
          res.forEach(tag=>{
            if (this.clientCollections.indexOf(tag._id) === -1) {
              this.clientCollections.push(tag._id)
            }
          })
          this.clientCollections.sort((a, b) => a.localeCompare(b));
          resolve()

        }).catch(err=>{
          console.error(`Error getting client's tags`, err)
          reject()
        })
      })

    },
    getNumberVideoPlatform() {
      let myFilter = {};
      //this.applyAdvancedFilters(myFilter)
      videoService
      .getVideoListPlugin(this.$auth.token(), {
        pagesize: 0,
        filter: JSON.stringify({ client: this.clientView, ...myFilter}),
      })
      .then((videos) => {
        this.totalNumberOfVideos = videos._size;
      });
    },

    applyAdvancedFilters(customSearchParameters) {
      let mySearchParameters = customSearchParameters || this.searchParameters;

      if (this.advancedFilters.length !== 2) {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }
        if (this.advancedFilters.indexOf('live') === -1) {
          mySearchParameters["$and"].push({"isLive":false});
        }
        if (this.advancedFilters.indexOf('vod') === -1) {
         mySearchParameters["$and"].push({"isLive":true});
        }
      }

      if(this.qualityFilters.length != 6)
      {
        if (!mySearchParameters["$and"]) {
          mySearchParameters["$and"] = [];
        }

        if(this.qualityFilters.indexOf('isSD') === -1)
          mySearchParameters["$and"].push({"isSD":false});

        if(this.qualityFilters.indexOf('isHD') === -1)
          mySearchParameters["$and"].push({"isHD":false});

        if(this.qualityFilters.indexOf('isFullHD') === -1)
                  mySearchParameters["$and"].push({"isFullHD":false});

        if(this.qualityFilters.indexOf('is2K') === -1)
                  mySearchParameters["$and"].push({"is2K":false});

        if(this.qualityFilters.indexOf('is4K') === -1)
                  mySearchParameters["$and"].push({"is4K":false});

        if(this.qualityFilters.indexOf('is8K') === -1)
                  mySearchParameters["$and"].push({"is8K":false});
          
      }

      if(!this.seeHidden)
      {
        if (!mySearchParameters["$or"]) {
          mySearchParameters["$or"] = [];
        }

        mySearchParameters["$or"].push({"isHidden":false});
        mySearchParameters["$or"].push({"isHidden":{"$exists": false}});

      }

      try {
        if(mySearchParameters["$and"].length === 0) {
          delete mySearchParameters["$and"];
        }
      } catch(err) {}
      //console.log('[Advanced filters]', this.isImbricated, mySearchParameters["$and"])
       
    },

    startTimeoutSearch() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {console.log(e)}
      //if (this.oldSearch !== this.search || this.advancedFilters.join('') !== this.oldAdvancedFilters || this.qualityFilters.join('') !== this.oldQualityFilters) {
        this.isGetInProgress = true;
        this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);
      /*} else {
        this.isGetInProgress = false;
      }*/
    },

    refreshManual() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {console.log(e)}
      this.isGetInProgress = true;
      this.timeoutSearch = setTimeout(this.onSearchBar, this.timeoutSearchDuration * 1000);
    },
    onSearchBar() {
      try {
        clearTimeout(this.timeoutSearch);
      } catch (e) {}
      let words = this.search.toLowerCase().split(" ");
      this.oldSearch = this.search;
      this.oldAdvancedFilters = this.advancedFilters.join("");
      this.oldQualityFilters = this.qualityFilters.join("");
      this.searchParameters = {};
      if ( this.search !== "") {
        this.searchParameters["$and"] = [];

        for (let word of words) 
        {
          if (word.startsWith("uuid:") || word.startsWith("id:")) 
          {
            let uuid = word.split(":")[1].split("+");
            if (uuid.length > 1) {
              this.searchParameters["$and"].push({ videoID: { $in: uuid } });
            } else {
              this.searchParameters["$and"].push({ videoID: word.split(":")[1] });
            }
          } else if (word.startsWith("description:")) {
            let decription = word.split(":")[1].split("+");
            decription = decription.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (decription.length > 1) {
              this.searchParameters["$and"].push({
                description: { $regex: decription.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                description: { $regex: decription[0] },
              });
            }
          } else if (word.startsWith("title:")) 
            {
            let title = word.split(":")[1].split("+");
            title = title.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (title.length > 1) {
              this.searchParameters["$and"].push({
                videoID: { $regex: title.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                videoID: { $regex: title[0] },
              });
            }

          } else if (word.startsWith("tags:")) 
            {
            let tags = word.split(":")[1].split("+");
            tags = tags.map((elem) => {
              return "(?i)^.*" + elem + ".*";
            });
            if (tags.length > 1) {
              this.searchParameters["$and"].push({
                tags: { $regex: tags.join("|") },
              });
            } else {
              this.searchParameters["$and"].push({
                tags: { $regex: tags[0] },
              });
            }

          } else {
            var objTest = { $regex: "(?i)^.*" + word + ".*" };
            this.searchParameters["$and"].push({
              $or: [{ videoID: objTest }, { tags: objTest }],
            });
          }
        }
      }

      if (this.selectedCollections.length>0 || this.exludedCollections.length>0)
          {

            if(this.selectedCollections.length>0)
            {
              this.searchParameters["$and"] = this.searchParameters["$and"] || [];
              this.searchParameters["$and"].push({
                collections:{$in:this.selectedCollections}
              })
            }
            if(this.exludedCollections.length>0)
            {
                            this.searchParameters["$and"] = this.searchParameters["$and"] || [];

              this.searchParameters["$and"].push({
                collections:{$nin:this.exludedCollections}
              })
            }
            
        }
      

      console.log("SEARCH PARAMETERS",this.searchParameters);

      let previousSearchParameters = this.getSearchParameters();
      this.saveSearchParameters();
      this.currentPage = 1;
      this.getVideos();
    },

    getSearchParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.searchParametersString = searchStorage.getItem(
          "QuanteecLabs_searchparameters"
        );
        result.searchParameters = JSON.parse(
          searchStorage.getItem("QuanteecLabs_searchparameters")
        );
        result.searchBar = searchStorage.getItem("QuanteecLabs_searchbar");
      } catch (err) {
        console.log(err);
      }

      return result;
    },
    saveSearchParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem(
          "QuanteecLabs_searchparameters",
          JSON.stringify(this.searchParameters)
        );
        searchStorage.setItem("QuanteecLabs_searchbar", this.search);

      } catch (err) {}
    },
    changeCollectionState(collection)
    {
      var selectedIndex = this.selectedCollections.indexOf(collection);
      var excludedIndex = this.exludedCollections.indexOf(collection)
      
      //TO-DO récupérer l'icone du collection et le changer 

      if((selectedIndex === -1 && excludedIndex === -1))
      {
          this.selectedCollections.push(collection)
          this.startTimeoutSearch();
      } else if (selectedIndex != -1 && excludedIndex === -1) {
          this.selectedCollections.splice(selectedIndex,1)
          this.exludedCollections.push(collection)
          this.startTimeoutSearch();
      } else {
          this.exludedCollections.splice(excludedIndex, 1)
          this.startTimeoutSearch();
      }
      this.clientCollections = this.clientCollections.splice(0)
    },

    updateVideoPluginList()
    {
        this.isGetInProgress = true;
        let params;
        if (this.$auth.getMyUser().roles.indexOf("admin") > -1) {
          let client = this.clientView;
          params = {
            filter: {
              client: client
            }
          };

        }
        videoService.refreshVideoPlugin(this.$auth.token(), params)
        .then(()=>{
            this.getClientCollections();
            this.getVideos(this.currentPage)
        })
        .catch(err=>{
          this.isGetInProgress = false;
            console.log(err)
        })
    },
    startModifyTags(video)
    {
      if (video.tags && video.tags !== '' && video.Tags !== '|:|') {
        video._tags = video.tags.split('|:|').map( x => {return {key: "", value: x}});
      } else {
        video._tags = [];
      }
      video._modifyTags = true;
      this.videos = this.videos.splice(0);
    },
    endModifyTags(video) {
      video.tags = video._tags.map(x => x.value).join('|:|');
      video._modifyTags = false;
      this.videos = this.videos.slice(0);
    },
    cancelModifyTags(video)
    {
      var tags = video.tags
      videoService.putVideoPluginById({tags: tags}, video._id, this.$auth.token()).then(() => {
          videos = videos.splice(0);
      }).catch((err) => {

      })
    },
    updateTags(video) {
        var tags = video._tags.map(elem => elem.value).join('|:|');
        videoService.putVideoPluginById({tags: tags}, video._id, this.$auth.token()).then(() => {
          videos = videos.splice(0);
        }).catch((err) => {

        })
    },
    updateDescription(video) {
        videoService.putVideoPluginById({description: video._desc}, video._id, this.$auth.token()).then(() => {
          video._modifyDescription = false;
          video.description = video._desc;
          this.videos = this.videos.splice(0);
        }).catch((err) => {

        })
    },
    cancelDescription(video){
      video._modifyDescription = false;
      this.videos = this.videos.splice(0);
    },
    openModalAuthorization()
    {
      this.selectedVideo._authorizedIPs = this.selectedVideo.authorizedIPs;
      this.selectedVideo._unauthorizedIPs = this.selectedVideo.unauthorizedIPs;
      this.selectedVideo._authorizedSubdomains = this.selectedVideo.authorizedSubdomains;
      this.selectedVideo._authorizedSubdomains = this.selectedVideo.unauthorizedSubdomains;
      this.selectedVideo._authorizedCountries = this.selectedVideo.authorizedCountries;
      this.selectedVideo._unauthorizedCountries = this.selectedVideo.unauthorizedCountries;
      this.selectedVideo._whitelistedWebsite = this.selectedVideo.whitelistedWebsite;
      this.selectedVideo._blacklistedWebsite = this.selectedVideo.blacklistedWebsite;
      this.selectedVideo._authorizedStream = this.selectedVideo.authorizedStream;
      this.authorizedVPNs = this.selectedVideo.authorizedVPNs;
      this.authorizedStream = this.selectedVideo.authorizedStream;
      this.selectedVideo._authorizedVPNsList = this.selectedVideo.authorizedVPNsList;
      this.ICEConfig = this.selectedVideo.ICEConfig;
      this.selectedVideo._authorizedIPsTags = this.selectedVideo.authorizedIPs.map(x => {return {key: x, value: x}});
      this.selectedVideo._unauthorizedIPsTags = this.selectedVideo.unauthorizedIPs.map(x => {return {key: x, value: x}});
      this.selectedVideo._authorizedSubdomainsTags = this.selectedVideo.authorizedSubdomains.map(x => {return {key: x, value: x}});
      this.selectedVideo._unauthorizedSubdomainsTags = this.selectedVideo.unauthorizedSubdomains.map(x => {return {key: x, value: x}});
      this.selectedVideo._authorizedCountriesTags = this.selectedVideo.authorizedCountries.map(x => {return {key: x, value: x}});
      this.selectedVideo._unauthorizedCountriesTags = this.selectedVideo.unauthorizedCountries.map(x => {return {key: x, value: x}});
      this.selectedVideo._whitelistedWebsiteTags = this.selectedVideo.whitelistedWebsite.map(x => {return {key: x, value: x}});
      this.selectedVideo._blacklistedWebsiteTags = this.selectedVideo.blacklistedWebsite.map(x => {return {key: x, value: x}});
      this.selectedVideo._authorizedVPNsTags = this.selectedVideo.authorizedVPNsList.map(x => {return {key: x, value: x}});
      this.customIce = JSON.parse(JSON.stringify(this.selectedVideo.customIce));
      this.selectedVideo._thumbnailURL = this.selectedVideo.thumbnailURL;
      this.isAuthorizedIPs = this.selectedVideo.isAuthorizedIPs;
      this.isAuthorizedSubdomains = this.selectedVideo.isAuthorizedSubdomains;
      this.isAuthorizedCountries = this.selectedVideo.isAuthorizedCountries;
      this.isAuthorizedWebsites = this.selectedVideo.isAuthorizedWebsites;
    },
    openCollectionAuthorization()
    {
      this.collectionAuth._authorizedIPs = []
      this.collectionAuth._unauthorizedIPs = []
      this.collectionAuth._authorizedCountries = []
      this.collectionAuth._unauthorizedCountries = []
      this.collectionAuth._whitelistedWebsite = []
      this.collectionAuth._blacklistedWebsite = []
      this.collectionAuth._authorizedVPNsList = []
      this.collectionAuth._authorizedIPsTags = []
      this.collectionAuth._unauthorizedIPsTags = []
      this.collectionAuth._authorizedCountriesTags = []
      this.collectionAuth._unauthorizedCountriesTags = []
      this.collectionAuth._whitelistedWebsiteTags = []
      this.collectionAuth._blacklistedWebsiteTags = []
      this.collectionAuth._authorizedVPNsTags = []
      this.collectionAuth.isAuthorizedIPs = "IPAuthorized";
      this.collectionAuth.isAuthorizedCountries = "countriesAuthorized"
      this.collectionAuth.isAuthorizedWebsites = "websitesAuthorized"
      this.collectionAuth.authorizedVPNs = true;
      this.collectionAuth.authorizedStream = true;
      this.collectionAuth.ICEConfig = "QUANTEEC"
      this.collectionAuth.modifyAuthorizedIPs = false;
      this.collectionAuth.modifyUnauthorizedIPs = false;
      this.collectionAuth.modifyAuthorizedCountries = false;
      this.collectionAuth.modifyUnauthorizedCountries = false;
      this.collectionAuth.modifyWhitelistedWebsites = false;
      this.collectionAuth.modifyBlacklistedWebsites = false;
      this.collectionAuth.modifyAuthorizedVPNs = false;
      this.collectionAuth.customIce = [];
    },

    updateAuthorization()
    {

      this.updateAuthorizedIPs();
      this.updateUnauthorizedIPs();
      this.updateAuthorizedSubdomains();
      this.updateUnauthorizedSubdomains();
      this.updateAuthorizedCountries();
      this.updateUnauthorizedCountries();
      this.updateWhitelistedWebsites();
      this.updateBlacklistedWebsites();
      this.updateAuthorizedVPNsList();
      var result = this.customIce.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })
      
      var dataToSend = {
        authorizedIPs : this.selectedVideo._authorizedIPs,
        unauthorizedIPs : this.selectedVideo._unauthorizedIPs,
        authorizedSubdomains : this.selectedVideo._authorizedSubdomains,
        unauthorizedSubdomains : this.selectedCollections._unauthorizedSubdomains,
        authorizedCountries : this.selectedVideo._authorizedCountries,
        unauthorizedCountries : this.selectedVideo._unauthorizedCountries,
        whitelistedWebsite : this.selectedVideo._whitelistedWebsite,
        blacklistedWebsite : this.selectedVideo._blacklistedWebsite,
        authorizedVPNs : this.authorizedVPNs,
        authorizedStream : this.authorizedStream,
        authorizedVPNsList : this.selectedVideo._authorizedVPNsList,
        ICEConfig : this.ICEConfig,
        customIce: result,
        thumbnailURL : this.selectedVideo._thumbnailURL,
        isAuthorizedIPs:this.isAuthorizedIPs,
        isAuthorizedCountries:this.isAuthorizedCountries,
        isAuthorizedWebsites:this.isAuthorizedWebsites,
        isDefaultAuthorizations:false,
      }


      videoService.putVideoPluginById(dataToSend, this.selectedVideo._id, this.$auth.token()).then(() => {
          
          
          this.selectedVideo.authorizedIPs = this.selectedVideo._authorizedIPs;
          this.selectedVideo.unauthorizedIPs = this.selectedVideo._unauthorizedIPs;
          this.selectedVideo.authorizedSubdomains = this.selectedVideo._authorizedSubdomains;
          this.selectedVideo.unauthorizedSubdomains = this.selectedVideo._unauthorizedSubdomains;
          this.selectedVideo.authorizedCountries = this.selectedVideo._authorizedCountries;
          this.selectedVideo.unauthorizedCountries = this.selectedVideo._unauthorizedCountries;
          this.selectedVideo.whitelistedWebsite = this.selectedVideo._whitelistedWebsite;
          this.selectedVideo.blacklistedWebsite = this.selectedVideo._blacklistedWebsite;
          this.selectedVideo.authorizedVPNs = this.authorizedVPNs;
          this.selectedVideo.authorizedStream = this.authorizedStream;
          this.selectedVideo.authorizedVPNsList = this.selectedVideo._authorizedVPNsList;
          this.selectedVideo.ICEConfig = this.ICEConfig;
          this.selectedVideo.customIce = result;
          this.selectedVideo.thumbnailURL = this.selectedVideo._thumbnailURL;
          this.selectedVideo.isAuthorizedIPs = this.isAuthorizedIPs;
          this.selectedVideo.isAuthorizedCountries = this.isAuthorizedCountries;
          this.selectedVideo.isAuthorizedWebsites = this.isAuthorizedWebsites;
          this.selectedVideo.isDefaultAuthorizations = false;

          this.videos = this.videos.splice(0);
        }).catch((err) => {
          console.log(err)
        })

    },
    updateCollectionAuthorization()
    {

      this.collectionAuth._authorizedIPs = this.collectionAuth._authorizedIPsTags.map(x => x.value);
      this.collectionAuth.modifyAuthorizedIPs = false;
      this.collectionAuth._unauthorizedIPs = this.collectionAuth._unauthorizedIPsTags.map(x => x.value);
      this.collectionAuth.modifyUnauthorizedIPs = false;
      this.collectionAuth._authorizedCountries = this.collectionAuth._authorizedCountriesTags.map(x => x.value);
      this.collectionAuth.modifyAuthorizedCountries = false;
      this.collectionAuth._unauthorizedCountries = this.collectionAuth._unauthorizedCountriesTags.map(x => x.value);
      this.collectionAuth.modifyUnauthorizedCountries = false;
      this.collectionAuth._whitelistedWebsite = this.collectionAuth._whitelistedWebsiteTags.map(x => x.value);
      this.collectionAuth.modifyWhitelistedWebsites = false;
      this.collectionAuth._blacklistedWebsite = this.collectionAuth._blacklistedWebsiteTags.map(x => x.value);
      this.collectionAuth.modifyBlacklistedWebsites = false;
      this.collectionAuth._authorizedVPNsList = this.collectionAuth._authorizedVPNsTags.map(x=>x.value);
      this.collectionAuth.modifyAuthorizedVPNs = false;
      /*var result = this.customIce.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })*/
      
      var dataToSend = {
        authorizedIPs : this.collectionAuth._authorizedIPs,
        unauthorizedIPs : this.collectionAuth._unauthorizedIPs,
        authorizedCountries : this.collectionAuth._authorizedCountries,
        unauthorizedCountries : this.collectionAuth._unauthorizedCountries,
        whitelistedWebsite : this.collectionAuth._whitelistedWebsite,
        blacklistedWebsite : this.collectionAuth._blacklistedWebsite,
        authorizedVPNs : this.collectionAuth.authorizedVPNs,
        authorizedStream : this.collectionAuth.authorizedStream,
        authorizedVPNsList : this.collectionAuth._authorizedVPNsList,
        ICEConfig : this.collectionAuth.ICEConfig,
        //customIce: result,
        thumbnailURL : this.collectionAuth._thumbnailURL,
        isAuthorizedIPs:this.collectionAuth.isAuthorizedIPs,
        isAuthorizedCountries:this.collectionAuth.isAuthorizedCountries,
        isAuthorizedWebsites:this.collectionAuth.isAuthorizedWebsites,
        isDefaultAuthorizations: false
      }


      videoService.putVideoPluginByCollection(dataToSend, this.collectionAuth.id, this.$auth.token()).then(() => {
          this.getVideos();
        }).catch((err) => {

        })

    },
    resetModalAuthorization()
    {
      this.selectedVideo._authorizedIPs = []
      this.selectedVideo._unauthorizedIPs = []
      this.selectedVideo._authorizedSubdomains = [];
      this.selectedVideo._unauthorizedSubdomains = [];
      this.selectedVideo._authorizedCountries = []
      this.selectedVideo._unauthorizedCountries = []
      this.selectedVideo._whitelistedWebsite = []
      this.selectedVideo._blacklistedWebsite = []
      this.isAuthorizedIPs = "IPAuthorized";
      this.isAuthorizedSubdomains = "SubdomainAuthorized"
      this.isAuthorizedCountries = "countriesAuthorized"
      this.isAuthorizedWebsites = "websitesAuthorized"
      this.authorizedVPNs = false;
      this.authorizedStream = false;
      this.selectedVideo._authorizedVPNsList = []
      this.ICEConfig = "QUANTEEC"
      this.modifyAuthorizedIPs = false;
      this.modifyUnauthorizedIPs = false;
      this.modifyAuthorizedSubdomains = false;
      this.modifyUnauthorizedSubdomains = false;
      this.modifyAuthorizedCountries = false;
      this.modifyUnauthorizedCountries = false;
      this.modifyWhitelistedWebsites = false;
      this.modifyBlacklistedWebsites = false;
      this.modifyAuthorizedVPNs = false;
      this.customIce = [];
    },
    
    resetDefaultAuthorization(){
      pluginParamsService.getDefaultParametersForClient(this.$auth.token())
      .then(params=>{
        var dataToSend = {
        authorizedIPs : params.authorizedIPs,
        unauthorizedIPs : params.unauthorizedIPs,
        authorizedSubdomains : params.authorizedSubdomains,
        unauthorizedSubdomains : params.unauthorizedSubdomains,
        authorizedCountries : params.authorizedCountries,
        unauthorizedCountries : params.unauthorizedCountries,
        whitelistedWebsite : params.whitelistedWebsite,
        blacklistedWebsite : params.blacklistedWebsite,
        authorizedVPNs : params.authorizedVPNs,
        authorizedStream : params.authorizedStream,
        authorizedVPNsList : params.authorizedVPNsList,
        ICEConfig : params.ICEConfig,
        customIce: params.customIce,
        isAuthorizedIPs:params.isAuthorizedIPs,
        isAuthorizedCountries:params.isAuthorizedCountries,
        isAuthorizedWebsites:params.isAuthorizedWebsites,
        isDefaultAuthorizations:true,
      }

     let result = params.customIce.map(x => {
         let myResult = {
           urls: x.urls
         }
         if (x.credential !== undefined) {
           myResult.username = x.username;
           myResult.credential = x.credential;
         }
         return myResult;
      })


      videoService.putVideoPluginById(dataToSend, this.selectedVideo._id, this.$auth.token()).then(() => {
          
          
          this.selectedVideo.authorizedIPs = dataToSend.authorizedIPs;
          this.selectedVideo.unauthorizedIPs = dataToSend.unauthorizedIPs;
          this.selectedVideo.authorizedSubdomains = dataToSend.authorizedSubdomains;
          this.selectedVideo.unauthorizedSubdomains = dataToSend.unauthorizedSubdomains;
          this.selectedVideo.authorizedCountries = dataToSend.authorizedCountries;
          this.selectedVideo.unauthorizedCountries = dataToSend.unauthorizedCountries;
          this.selectedVideo.whitelistedWebsite = dataToSend.whitelistedWebsite;
          this.selectedVideo.blacklistedWebsite = dataToSend.blacklistedWebsite;
          this.selectedVideo.authorizedVPNs = dataToSend.authorizedVPNs;
          this.selectedVideo.authorizedStream = dataToSend.authorizedStream;
          this.selectedVideo.authorizedVPNsList = dataToSend.authorizedVPNsList;
          this.selectedVideo.ICEConfig = dataToSend.ICEConfig;
          this.selectedVideo.customIce = result;
          this.selectedVideo.isAuthorizedIPs = dataToSend.isAuthorizedIPs;
          this.selectedVideo.isAuthorizedCountries = dataToSend.isAuthorizedCountries;
          this.selectedVideo.isAuthorizedWebsites = dataToSend.isAuthorizedWebsites;
          this.selectedVideo.isDefaultAuthorizations = true;

          this.videos = this.videos.splice(0);
        }).catch((err) => {
          console.log(err)
        })
      }).catch(err=>{
        console.log(err)
      })
    },

    updateAuthorizedIPs()
    {
      this.selectedVideo._authorizedIPs = this.selectedVideo._authorizedIPsTags.map(x => x.value);
      this.modifyAuthorizedIPs = false;
    },
    cancelAuthorizedIPs()
    {
      this.selectedVideo.authorizedIPsTags = this.selectedVideo.authorizedIPs.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedIPs = false;
    },
    updateUnauthorizedIPs()
    {
      this.selectedVideo._unauthorizedIPs = this.selectedVideo._unauthorizedIPsTags.map(x => x.value);
      this.modifyUnauthorizedIPs = false;
    },
    cancelUnauthorizedIPs()
    {
      this.selectedVideo.unauthorizedIPsTags = this.selectedVideo.unauthorizedIPs.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedIPs = false;
    },
    updateAuthorizedSubdomains()
    {
      this.selectedVideo._authorizedSubdomains = this.selectedVideo._authorizedSubdomainsTags.map(x => x.value);
      this.modifyAuthorizedSubdomains = false;
    },
    cancelAuthorizedSubdomains()
    {
      this.selectedVideo.authorizedSubdomains = this.selectedVideo.authorizedSubdomains.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedSubdomains = false;
    },
    updateUnauthorizedSubdomains()
    {
      this.selectedVideo._unauthorizedSubdomains = this.selectedVideo._unauthorizedSubdomainsTags.map(x => x.value);
      this.modifyUnauthorizedSubdomains = false;
    },
    cancelUnauthorizedSubdomains()
    {
      this.selectedVideo.unauthorizedSubdomainsTags = this.selectedVideo.unauthorizedSubdomains.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedSubdomains = false;
    },
    updateAuthorizedCountries()
    {
      this.selectedVideo._authorizedCountries = this.selectedVideo._authorizedCountriesTags.map(x => x.value);
      this.modifyAuthorizedCountries = false;
    },
    cancelAuthorizedCountries()
    {
      this.selectedVideo._authorizedCountriesTags = this.selectedVideo.authorizedCountries.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedCountries = false;
    },
    updateUnauthorizedCountries()
    {
      this.selectedVideo._unauthorizedCountries = this.selectedVideo._unauthorizedCountriesTags.map(x => x.value);
      this.modifyUnauthorizedCountries = false;
    },
    cancelUnauthorizedCountries()
    {
      this.selectedVideo._unauthorizedCountriesTags = this.selectedVideo.unauthorizedCountries.map(x => {return {key: x, value: x}});
      this.modifyUnauthorizedCountries = false;
    },
    updateWhitelistedWebsites(){
      this.selectedVideo._whitelistedWebsite = this.selectedVideo._whitelistedWebsiteTags.map(x=>x.value);
      this.modifyWhitelistedWebsites = false;
    },
    cancelWhitelistedWebsites(){
      this.selectedVideo._whitelistedWebsiteTags = this.selectedVideo._whitelistedWebsite.map(x => {return {key: x, value: x}});
      this.modifyWhitelistedWebsites = false;
    },

    updateBlacklistedWebsites(){
      this.selectedVideo._blacklistedWebsite = this.selectedVideo._blacklistedWebsiteTags.map(x=>x.value);
      this.modifyBlacklistedWebsites = false;
    },
    cancelBlacklistedWebsites(){
      this.selectedVideo._blacklistedWebsiteTags = this.selectedVideo._blacklistedWebsite.map(x => {return {key: x, value: x}});
      this.modifyBlacklistedWebsites = false;
    },

    updateAuthorizedVPNsList(){
      this.selectedVideo._authorizedVPNsList = this.selectedVideo._authorizedVPNsTags.map(x=>x.value);
      this.modifyAuthorizedVPNs = false;
    },
    cancelAuthorizedVPNsList(){
      this.selectedVideo._authorizedVPNsTags = this.selectedVideo._authorizedVPNsList.map(x => {return {key: x, value: x}});
      this.modifyAuthorizedVPNs = false;
    },

    addSTUN(){
      this.customIce.push({_id: uuidv4(), urls: ['']});
    },

    addTURN(){
      this.customIce.push({_id: uuidv4(), urls: [''], username: '', credential: '', _showCredential: 'password'});
    },
    addUrl(ice) {
      ice.urls.push('');
    },
    removeUrl(ice, idx) {
      ice.urls.splice(idx, 1);
    },
    removeICE(indexIce) {
      this.customIce.splice(indexIce, 1);
    },
    openModalThumbnail()
    {
      this.selectedVideo._thumbnailURL = this.selectedVideo.thumbnailURL; 
    },
    changeActiveSort(value, defaultOrder) {
      var sortObject = {};
      if (value !== this.activeSort) {
        this.activeSortOrder = (defaultOrder !== undefined) ? defaultOrder : 1;
        this.activeSort = value;
      } else {
        this.activeSortOrder = this.activeSortOrder === 1 ? -1 : 1;
      }
      this.saveSortParameters();
      sortObject[this.activeSort] = this.activeSortOrder;
      this.mySort = JSON.stringify(sortObject);
      this.getVideos(this.currentPage);
    },
    saveSortParameters() {
      try {
        let searchStorage = sessionStorage;
        searchStorage.setItem("QuanteecLabs_sortparam", this.activeSort);
        searchStorage.setItem(
          "QuanteecLabs_sortorder",
          this.activeSortOrder === 1 ? "asc" : "desc"
        );
      } catch (err) {}
    },
    getSortParameters() {
      let result = {};
      try {
        let searchStorage = sessionStorage;
        result.sort = searchStorage.getItem("QuanteecLabs_sortparam");
        result.sortOrder = searchStorage.getItem("QuanteecLabs_sortorder");
        if (result.sortOrder === "asc") {
          result.sortOrder = 1;
        } else {
          result.sortOrder = -1;
        }
      } catch (err) {}

      return result;
    },
    getListAllVideos()
    {
      return this.videos;
    },
    checkAllSelected() {
      let allVideos = this.getListAllVideos();
      let oneNotSelected = allVideos.findIndex(x => !x._isSelected);
      if (oneNotSelected > -1) {
        this.isSelectAll = false;
      } else {
        this.isSelectAll = true;
      }
    },

    updateSelectedNumber() {
      let allVideos = this.getListAllVideos();
      this.nbrVideoSelected = allVideos.filter(x => x._isSelected).length;
      this.checkAllSelected();
    },
    openAnalyticsForVideo(video) {
      this.$router.push('/analytics?video=' + video.videoID);
    },
    updateHideVideo(){
      let allVideos = this.getListAllVideos();
      let arrayPromise = []
      for (var video of allVideos) {
        if (video._isSelected) {
         video.isHidden = true;
         arrayPromise.push(this.updateHidden(video));
        }
      }
      Promise.all(arrayPromise).then(()=>{
        this.nbrVideoSelected = 0;
        this.refreshManual()
      }).catch(err=>{
        console.log(err)
      })
    },

    updateUnhideVideo(){
      let allVideos = this.getListAllVideos();
      let arrayPromise = []
      for (var video of allVideos) {
        if (video._isSelected) {
         video.isHidden = false;
         arrayPromise.push(this.updateHidden(video));
        }
      }
      Promise.all(arrayPromise).then(()=>{
        this.nbrVideoSelected = 0;
        this.refreshManual()
      }).catch(err=>{
        console.log(err)
      })
    },    

    updateHidden(video) {
      return new Promise((resolve, reject) => {
        videoService.putVideoPluginById({isHidden: video.isHidden}, video._id, this.$auth.token()).then(() => {
            video._isSelected = false;
            resolve();
          }).catch((err) => {
            reject(err);
        })
      })

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.previewContainer {
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
  padding-top: 56.25%;
  background-color: black;
}

.previewImg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.scrollmenu {
  display: flex;
  justify-content: space-between;
  overflow: auto;
  white-space: nowrap;
}

.defaultAuthBadge {
  font-size: 0.8rem;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(#14BF98, 0.2);
}

.hiddenAuthBadge {
  font-size: 0.8rem;
  padding: 5px;
  border-radius: 10px;
  background-color: rgba(#bf4a14, 0.2);
}

.tagButton {
  cursor:pointer;
}

.tag-not-selected {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  background-color:#2a5d77;
  color:white;
  
}

.tag-selected {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  background-color:#14BF98;
  color:white;

}

.tag-excluded {
  border: 1px solid black;
  border-radius: 10px;
  min-width: 50px;
  display: inline-block;
  text-align:center;
  margin-right:10px;
  margin-bottom:10px;
  background-color:red;
  color:white;

}

.noDisplay {
  display: none;
}

</style>
